import type { FaireProductEntity } from "../../entity_types/product";

export const p_4m2nun76sq: FaireProductEntity = {
  token: "p_4m2nun76sq",
  type: "product",
  name: "Northwoods",
  brandName: "Lakehouse Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/48e94325017dfc2eaa0fa076d92a053d0241f24a19b10bbc1067151e6a977ad3.jpeg",
  priceDollars: 15.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6309ef848a02ab81a26eaa67f0fc5ab5cff7d80817e5182a4b1aef57f5096e22.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
